module.exports = __webpack_public_path__ + "static/media/eyeLookDownLeft.e942b3e6.obj";